export const catalogPuppy = [
  {
    id: 'small1',
    type: 'small',
    label: 'start',
    link: '/dog/product/healthy-start-dlia-shchienkov-mielkikh-i-karlikovykh-porod-kuritsa',
    title: 'Для поддержания здорового роста и&nbsp;иммунитета',
  },
  {
    id: 'small2',
    type: 'small',
    label: 'skin',
    link: '/dog/product/puppy-small-sensitive-skin-salmon',
    title: 'Для поддержания здоровья кожи и&nbsp;шерсти',
    isNew: true,
  },
  {
    id: 'medium1',
    type: 'medium',
    label: 'start',
    link: '/dog/product/healthy-start-dlia-shchienkov-sriednikh-porod-kuritsa',
    title: 'Для поддержания здорового роста и&nbsp;иммунитета',
  },
  {
    id: 'medium2',
    type: 'medium',
    label: 'digestion',
    link: '/dog/product/sensitive-digestion-dlia-shchienkov',
    title: 'Для поддержания здорового пищеварения',
  },
  {
    id: 'medium3',
    type: 'medium',
    label: 'skin',
    link: '/dog/product/proplan-sensitive-skin-dlia-shchienkov',
    title: 'Для поддержания здоровья кожи и&nbsp;шерсти',
  },
  {
    id: 'big-athlete1',
    type: 'big-athlete',
    label: 'start',
    link: '/dog/product/healthy-start-dlya-shchenkov-krupnyh-porod',
    title: 'Для развития здорового зрения и&nbsp;мозга',
  },
  {
    id: 'big-strong1',
    type: 'big-strong',
    label: 'start',
    link: '/dog/product/pro-plan-r-healthy-start-r-dlia-shchienkov-krupnykh-porod-moshchnogho-tieloslozhieniia-kuritsa-dog',
    title: 'Для развития здорового зрения и&nbsp;мозга',
  },
]

export const catalogAdult = [
  {
    id: 'adult-small1',
    type: 'small',
    label: 'skin',
    link: '/products?%2Fproducts=&species=971&diet=0&f%5B0%5D=dog_age%3A1301&f%5B1%5D=proplan_diet%3A2381&f%5B2%5D=proplan_size%3A1056&q=',
    title: 'Для собак мелких и&nbsp;карликовых пород с&nbsp;чувствительной кожей',
  },
  {
    id: 'adult-small2',
    type: 'small',
    label: 'digestion',
    link: '/dog/product/sensitive-digestion-dlia-sobak-mielkikh-porod',
    title: 'Для собак мелких и&nbsp;карликовых пород с&nbsp;чувствительным пищеварением',
  },
  {
    id: 'adult-small3',
    type: 'small',
    label: 'picky',
    link: '/dog/product/duo-delice-dlia-sobak-mielkikh-porod-goviadina',
    title: 'Для собак мелких и&nbsp;карликовых пород с&nbsp;двойной текстурой гранул',
  },
  {
    id: 'adult-small4',
    type: 'small',
    label: 'everyday',
    link: '/products?%2Fproducts=&species=971&diet=0&f%5B0%5D=dog_age%3A1301&f%5B1%5D=proplan_diet%3A4577&f%5B2%5D=proplan_size%3A1056&q=',
    title: 'Для собак мелких и&nbsp;карликовых пород',
  },
  {
    id: 'adult-medium1',
    type: 'medium',
    label: 'skin',
    link: '/dog/product/sensitive-skin-dlia-sobak-sriednikh-porod',
    title: 'Для собак средних пород с&nbsp;чувствительной кожей',
  },
  {
    id: 'adult-medium2',
    type: 'medium',
    label: 'digestion',
    link: '/dog/product/dlya-sobak-s-chuvstvitelnym-pishchevareniem',
    title: 'Для собак средних пород с&nbsp;чувствительным пищеварением',
  },
  {
    id: 'adult-medium3',
    type: 'medium',
    label: 'picky',
    link: '/dog/product/proplan-duo-delice-dlia-vzroslykh-sobak',
    title: 'Рацион с&nbsp;двойной текстурой гранул для собак средних и&nbsp;крупных пород',
  },
  {
    id: 'adult-medium4',
    type: 'medium',
    label: 'everyday',
    link: '/dog/product/everyday-nutrition-dlya-sobak-s-izbytochnomu-vesu',
    title: 'Для собак средних пород',
  },
  {
    id: 'adult-big-athlete1',
    type: 'big-athlete',
    label: 'skin',
    link: '/dog/product/proplan-sensitive-skin-dlia-sobak-krupnykh-porod',
    title: 'Для собак крупных пород с&nbsp;атлетическим телосложением с&nbsp;чувствительной кожей',
  },
  {
    id: 'adult-big-athlete2',
    type: 'big-athlete',
    label: 'digestion',
    link: '/dog/product/dlya-sobak-krupnyh-porod-pishchevareniem',
    title: 'Для собак крупных пород с&nbsp;атлетическим телосложением с&nbsp;чувствительным пищеварением',
  },
  {
    id: 'adult-medium3',
    type: 'big-athlete',
    label: 'picky',
    link: '/dog/product/proplan-duo-delice-dlia-vzroslykh-sobak',
    title: 'Рацион с&nbsp;двойной текстурой гранул для собак средних и&nbsp;крупных пород',
  },
  {
    id: 'adult-big-athlete3',
    type: 'big-athlete',
    label: 'everyday',
    link: '/dog/product/proplan-everyday-nutrition-dlia-sobak-krupnykh',
    title: 'Для собак крупных пород с&nbsp;атлетическим телосложением',
  },
  {
    id: 'adult-big-strong1',
    type: 'big-strong',
    label: 'skin',
    link: '/dog/product/sensitive-skin-dlya-sobak-krupnyh-porod-s-chuvstvitelnoj-kozhej',
    title: 'Для собак крупных пород с&nbsp;мощным телосложением с&nbsp;чувствительной кожей',
  },
  {
    id: 'adult-big-strong2',
    type: 'big-strong',
    label: 'digestion',
    link: '/dog/product/proplan-sensitive-digestion-dlia-sobak-krupnykh-porod',
    title: 'Для собак крупных пород с&nbsp;мощным телосложением с&nbsp;чувствительным пищеварением',
  },
  {
    id: 'adult-big-strong3',
    type: 'big-strong',
    label: 'everyday',
    link: '/dog/product/proplan-everyday-nutrition-dla-sobak-krupnykh-porod',
    title: 'Для собак крупных пород с&nbsp;мощным телосложением',
  },
  {
    id: 'adult-medium3',
    type: 'big-strong',
    label: 'picky',
    link: '/dog/product/proplan-duo-delice-dlia-vzroslykh-sobak',
    title: 'Рацион с&nbsp;двойной текстурой гранул для собак средних и&nbsp;крупных пород',
  },
]
